export default __webpack_public_path__ + "static/media/squared_plus.bffd609e.svg";